export default "__VITE_ASSET__Dvm_Ek8n__"